
import { useState,useEffect } from "react";
import viewmyresultapi from '../api/viewmyresultapi';
import loginapi from '../api/login';
import { useNavigate } from "react-router-dom";
import { APISERVERURL } from '../APIServerURL';
import OfferedCoursesS from '../studentcomponents/OfferedCoursesS';
import SelectedCourseList from '../studentcomponents/SelectedCourseList';
import PaymentDetails from '../studentcomponents/PaymentDetails';
import DeleteConfirmation from '../studentcomponents/ConfirmDelete';

import { FaSave } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";

function DoFormFillup({accessToken,setAccessToken,setRefreshFailed,examsession}) {
  const navigate = useNavigate();   
  const [selectedSemester,setSelectedSemester]=useState(-1);
  const [isAppLoaded,setIsAppLoaded]=useState(true);
  const [semOfferedCourses,setSemOfferedCourses]=useState(null);  
  const [selectedCourses,setSelectedCourses]=useState(null);

  const [showModal, setShowModal] = useState(false);

  const [loggedInStudent,setLoggedInStudent]=useState(null);
  const session=examsession;

  const [isCourseSelectionOk,setIsCourseSelectionOk]=useState(false);
  const [isPaymentOk,setIsPaymentOk]=useState(false);
  const [paymentError,setPaymentError]=useState([]);
  const [courseError,setCourseError]=useState([]);

  const [submissionStatus,setSubmissionStatus]=useState('submitted');
   const [isOpen,setIsOpen]=useState('NO');
  
  useEffect(()=>{
    setIsAppLoaded(false);
    const fetchAT=async ()=>{
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/getLoggedInStudentDetails',{id:1},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.student));
        setLoggedInStudent(response.data.student);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        const response=await viewmyresultapi.post('/getLoggedInStudentDetails',{id:1},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.student));
                        setLoggedInStudent(response.data.student);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[]);
  
  const proceedToSubmit = () => {
    if (paymentError.length === 0 && courseError.length === 0) {
  setShowModal(true);
}
  };

  const handleSubmit = async () => {
    if (paymentError.length === 0 && courseError.length === 0) {
  try{       
       //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
       const response=await viewmyresultapi.post('/confirmSubmit',{semester:selectedSemester,session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
       //alert("load courses "+JSON.stringify(response.data));
       //setSemOfferedCourses(response.data);
       //alert(response.data);
        setSubmissionStatus(response.data.rv.submission_status);
       setShowModal(false);
       }
       catch(err)
       {
         try{
           const config = { withCredentials: true };
           const x=await loginapi.get('/getAccessToken',config);            
           const nat=x['data']['accessToken'];
           const ufn=x['data']['userFullName'];
           const un=x['data']['userName'];
           const lt=x['data']['loginType'];
           //alert(nat);
           setAccessToken(nat);
           setRefreshFailed(false);  
                   
          
             if(lt.toLowerCase()==="student")
               {
                     try{       
                       //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                       const response=await viewmyresultapi.post('/confirmSubmit',{semester:selectedSemester,session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                       //alert("load courses "+JSON.stringify(response.data));
                       //setSemOfferedCourses(response.data);
                       //alert(response.data);
                           setSubmissionStatus(response.data.rv.submission_status);
                       setShowModal(false);
                   }
                   catch(err)
                   {
                     alert('refresh failed unusual'+ "line 50");
                     setAccessToken('');
                     setRefreshFailed(true);  
                   }
                 }
           }
           catch(err)
           {
             //alert('dd');
             setAccessToken(''); 
             setRefreshFailed(true);              
           }
       }         
        finally
           {
             setIsAppLoaded(true);
             //alert('app loaded'+accessToken);
           }
}
  };

const handleDownload=async (e)=>{
    setIsAppLoaded(false);
  e.preventDefault();
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    setIsAppLoaded(false);
    const response= await viewmyresultapi.post('/getMyFormFillup',{semester:selectedSemester,session},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
    downloadFile(response.data);
  }
  catch(err)
  {
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await viewmyresultapi.post('/getMyFormFillup',{semester:selectedSemester,session},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        
        alert('unusual error newposts.js');
        setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}


  function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/studentpdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsAppLoaded(true);
      });
    });
  }

  const handleGoBack = () => {
    navigate(`/`); 
  };
   
  const loadOfferedCourses=async ()=>{
    //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
     try{       
       //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
       const response=await viewmyresultapi.post('/getOfferedCourses',{program:loggedInStudent.programme_code,specialisation:loggedInStudent.MajorSub.toUpperCase(),semester:selectedSemester},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
       //alert("load courses "+JSON.stringify(response.data));
       setSemOfferedCourses(response.data);
       //alert(response.data);
       }
       catch(err)
       {
         try{
           const config = { withCredentials: true };
           const x=await loginapi.get('/getAccessToken',config);            
           const nat=x['data']['accessToken'];
           const ufn=x['data']['userFullName'];
           const un=x['data']['userName'];
           const lt=x['data']['loginType'];
           //alert(nat);
           setAccessToken(nat);
           setRefreshFailed(false);  
                   
          
             if(lt.toLowerCase()==="student")
               {
                     try{       
                       //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                       const response=await viewmyresultapi.post('/getOfferedCourses',{program:loggedInStudent.programme_code,specialisation:loggedInStudent.MajorSub,semester:selectedSemester},{headers:{'Authorization':`Bearer ${nat}`}});                            
                       //alert("load courses "+JSON.stringify(response.data));
                       setSemOfferedCourses(response.data);
                       //alert(response.data);
                   }
                   catch(err)
                   {
                     alert('refresh failed unusual'+ "line 50");
                     setAccessToken('');
                     setRefreshFailed(true);  
                   }
                 }
           }
           catch(err)
           {
             //alert('dd');
             setAccessToken(''); 
             setRefreshFailed(true);              
           }
       }         
        finally
           {
             setIsAppLoaded(true);
             //alert('app loaded'+accessToken);
           }
   }
 
   const loadSelectedCourses=async ()=>{
     //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/getSemesterSelectedCourses',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify( response.data.data)); 
        setSelectedCourses(response.data.data);
        //alert(response.data);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await viewmyresultapi.post('/getSemesterSelectedCourses',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.data)); 
                        setSelectedCourses(response.data.data);
                        //alert(response.data);
                    }
                    catch(err)
                    {
                      alert('refresh failed unusual'+ "line 50");
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
   }
   const loadSubmissionStatus=async ()=>{
     //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/loadSubmissionStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify( response.data.data)); 
        setSubmissionStatus(response.data.submissionStatus);
        //alert(response.data.submissionStatus);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await viewmyresultapi.post('/loadSubmissionStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.data)); 
                        //setSelectedCourses(response.data.data);
                         setSubmissionStatus(response.data.submissionStatus);
                         //alert(response.data.submissionStatus);
                    }
                    catch(err)
                    {
                      alert('refresh failed unusual'+ "line 50");
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
   }

   const loadOpenStatus=async ()=>{
     //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/loadOpenStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify( response.data.data)); 
        setIsOpen(response.data.status);
        //alert(response.data.submissionStatus);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await viewmyresultapi.post('/loadOpenStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.data)); 
                        //setSelectedCourses(response.data.data);
                         setIsOpen(response.data.status);
                         //alert(response.data.submissionStatus);
                    }
                    catch(err)
                    {
                      alert('refresh failed unusual'+ "line 50");
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
   }

   useEffect( ()=>{
    if(loggedInStudent)
    {
      loadOpenStatus();
      loadSubmissionStatus();
      loadOfferedCourses();
      loadSelectedCourses();
    }
  },[selectedSemester]);
  
  const onSemClick = async (event) => {
    setSelectedSemester(event.target.value);
    //retrieve offered courses for the prog specialisation and sem     
  };

  function getSelectSemesterPanel()
  {
    const noofsem=8;
    const semesters =Array.from({ length: noofsem }, (_, index) => ({
      id: index + 1,
      text: `sem${index + 1}`
    }));
    return (
      <div className="semcontainer marginTopm">       
        <div className="album">
          {semesters.map(item => (
            <button
              value={item.id}
              key={item.id}
              className={ item.id==selectedSemester?'circlebutton circularbuttonactive':'circlebutton circularbuttoninactive'}
              onClick={(e)=>{onSemClick(e)}}
            >
              {item.text}
            </button>
          ))}
        </div>
      </div>
    );
  }
  
  function getOfferedCourses()
  {
    return (
      <div className="verticaldiv centrediv fullWidth marginTopm">
         <OfferedCoursesS accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed} session={session} data={semOfferedCourses} setSelectedCourses={setSelectedCourses} selectedCourses={selectedCourses} semester={selectedSemester} />
      </div>
    );
  }

  let progSpec="";
  if(loggedInStudent)
  {
   progSpec=loggedInStudent.rollno+" "+loggedInStudent.programme_code+","+loggedInStudent.MajorSub;
  }

    return (
      <main className="w-full">

        <div className="flex flex-col items-center w-full">

        <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">FORM FILLUP</h1>
            <p className="w-full text-center text-xs text-gray-500"> <span>{session} Examinations</span></p>     
          </div>

          <div className="w-full mt-4 flex flex-col items-center justify-center">
          {isAppLoaded ? ( 
            <>
            <p className="text-center">{progSpec}</p>
            {loggedInStudent && getSelectSemesterPanel()}
            {isOpen.toUpperCase()==='YES' && loggedInStudent && selectedSemester>0 && submissionStatus.toUpperCase()!=="SUBMITTED" && getOfferedCourses()}
            {loggedInStudent &&selectedSemester<0 && <p>Please select a Semester</p>}
            {isOpen.toUpperCase()==='NO' && selectedSemester>0 && <p className="text-center w-full p-1 mt-5">FORM FILLUP IS NOT OPEN FOR SEMESTER {selectedSemester}</p>}
            {isOpen.toUpperCase()==='YES' && loggedInStudent && selectedSemester>0 && <SelectedCourseList setCourseError={setCourseError} setIsCourseSelectionOk={ setIsCourseSelectionOk} selectedCoursesAtParent={selectedCourses} selectedSemester={selectedSemester} session={session} accessToken={accessToken} 
            setAccessToken={setAccessToken}
            setRefreshFailed={setRefreshFailed}></SelectedCourseList> }     

            {isOpen.toUpperCase()==='YES' && loggedInStudent && selectedSemester>0 &&  <PaymentDetails submissionStatus={submissionStatus} setPaymentError={setPaymentError} setIsPaymentOk={setIsPaymentOk} selectedSemester={selectedSemester} session={session} accessToken={accessToken} 
            setAccessToken={setAccessToken}
            setRefreshFailed={setRefreshFailed}></PaymentDetails> }    

             {isOpen.toUpperCase()==='YES' && loggedInStudent && selectedSemester>0   && <div className="flex flex-col width1000 ">
               
                <DeleteConfirmation
              isOpen={showModal}
              yesButtonText="CONFIRM"
              warningMessageText="You won't be able to make changes after submission. Please make sure everything is done correctly before submission. Click on CONFIRM if you are sure."
              onCancel={() => setShowModal(false)}
              onDelete={() => {
                setShowModal(false);
                //call the actual delete function
                handleSubmit();                
              }}
            />  

            {courseError.length !== 0 && (
  <div className="flex flex-col justify-center text-red-700">
    {courseError.map((err, index) => (
      <p key={index} className="text-center">{err}</p>
    ))}
  </div>
)}

{paymentError.length !== 0 && (
  <div className="flex flex-col justify-center text-red-700">
    {paymentError.map((err, index) => (
      <p key={index} className="text-center">{err}</p>
    ))}
  </div>
)}
            

                <div className="formfillupview  width1000 flex justify-between roundeddiv mt-4 mb-4 p-1">
                
                {submissionStatus.toUpperCase()!=='SUBMITTED' &&(<button
  onClick={proceedToSubmit}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-green-500 hover:bg-green-800 m-1"
>
  <FaSave className="w-5 h-5" />
  SUBMIT
</button>)}

{submissionStatus.toUpperCase()==='SUBMITTED' &&(<button
  
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-gray-500 hover:bg-gray-800 m-1"
>
  <FaSave className="w-5 h-5" />
  ALREADY SUBMITTED
</button>)}

{true &&(<button
  onClick={handleDownload}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-orange-600 hover:bg-orange-700 m-1"
>
<AiOutlineDownload size={20} />
  PDF
</button>)}

             </div> 

             </div> }           
            </>           
          ) : (
            <p>Please wait...</p>
          )}
          </div>
        </div>

     
      </main>
    )
  }
  
  export default DoFormFillup